/**
 * Created by fwt on 2018/8/20.
 */
import React,{Component} from 'react';
import "./style.less"
import {NavBar, Checkbox, List, Toast, ListView, Icon,Tabs} from "antd-mobile";
import {invoiceOrderList,getinvicecount} from "../../service/invoiceService"
import {connect} from "react-redux";
const notInvoice = require('../../common/image/notInvoice.png');
const dataError = require('../../common/image/dataError.png');
const CheckboxItem = Checkbox.CheckboxItem;
let invoiceId=[];
let pageIndex = 1;
let pageSize = 20;
let tabIndex = 0
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Invoice extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state={
            dataSource,
            isLoading: true,
            notDataLoading:0,
            data:[],
            totalNum:"",
            allCheck:false,
            invoiceId:[],
            invoicePic:0,
            tabs : [
                { title: "普通票" },
                // { title: "数电票" },
            ],
            inviceCount:0,
        }
    }
    componentDidMount() {
        // console.log(this.props);
        pageIndex = 1;
        tabIndex = 0;
        this.initData();
    }
    initData(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                pageSize:pageSize,
                pageNum:pageIndex,
                // type:this.props.location.state == "city" ? "0" : "1",
                type:this.props.location.state,
                invoiceType:tabIndex+1
            },
        };
        invoiceOrderList(params).then(res => {
            if (res.data.code === '0000') {
                if (res.data.data.list.length > 0) {
                    // res.data.data.list.map((res)=>{
                    //     res.checkBox = false;
                    //     invoiceId.push(res.id);
                    //     res.invoiceAmountAvailable = parseFloat(res.invoiceAmountAvailable)
                    // });
                    this._setDataSource(res.data.data);
                    // this.setState({data: res.data.data.list,});
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else{
                Toast.info(res.data.msg,3) ;
                this.setState({notDataLoading: 2,isLoading: false});
            }
        }).catch(function (error) {
            console.log(error);
        });
        let params1={
            token:this.props.userInfo.token,
            source:1,
        };
        getinvicecount(params1).then(res => {
            if (res.data.code === '0000') {
                this.setState({inviceCount:res.data.data})
            }else{
                Toast.info(res.data.msg,3) ;
            }
        })
    }
    //数据拼接
    _setDataSource(data) {
        data.list.map((res)=>{
            // res.checkBox = false;
            invoiceId.push(res.id);
            res.invoiceAmountAvailable = parseFloat(res.invoiceAmountAvailable)
        });
        const allData = [...this.state.data, ...data.list];
        // let allData = [];
        // allData = this.state.data.push(data.list)
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            pageIndex = ++pageIndex
            this.initData();
        }
    };

    onChange = (val,e,index) => {
        let data = this.state.data;
        let flag = true;
        let id = this.state.invoiceId;
        let pic = this.state.invoicePic;
        let disabled = {}
        // console.log(this.state.invoiceId)
        data.map((res,i)=>{
            if(res.id == this.state.invoiceId[0]){
                disabled = res
            }
            if(!res.checkBox){
                flag = false
            }
        });
        // console.log(val,e.target.checked,index)
         //改变列表点击的选择状态
         if(e.target.checked === true){ 
            if(val.invoiceAmountAvailable == 0){
                Toast.info("订单价格为0，不可开票",3)
                val.checkBox = false;
                return;
           }
            if((val.isBwy == disabled.isBwy && val.invoiceSign == disabled.invoiceSign) || disabled.isBwy == undefined){
                val.checkBox = true;
                id.push(val.id);
                pic+=val.invoiceAmountAvailable;
            }else{
                Toast.info("该订单不能合并开票",3)
                val.checkBox = false;
                e.target.checked = false
            }
        }else if(e.target.checked === false){
            val.checkBox = false;
            id.splice(id.findIndex(item => item === val.id), 1)
            pic -= val.invoiceAmountAvailable;

        }

        //如果列表中没有全部选中，那么全选按钮不能未选中状态
        if(flag){
            this.setState({allCheck:true});
        }else{
            this.setState({allCheck:false});
        }
        this.setState({data,invoiceId:id,invoicePic:pic});
    };
    onChange1 = (val) => {
        console.log(val)
        val.checkBox = !val.checkBox
        let data = this.state.data;
        let id = this.state.invoiceId;
        let pic = this.state.invoicePic;
        let disabled = {}
        data.map((res,i)=>{
            if(res.id == this.state.invoiceId[0]){
                disabled = res
            }
        });
        if(val.checkBox){ 
            if(val.invoiceAmountAvailable == 0){
                Toast.info("订单价格为0，不可开票",3)
                val.checkBox = false;
                return;
           }
            if((val.isBwy == disabled.isBwy && val.invoiceSign == disabled.invoiceSign) || disabled.isBwy == undefined){
                id.push(val.id);
                pic+=val.invoiceAmountAvailable;
            }else{
                Toast.info("该订单不能合并开票",3)
                val.checkBox = false;
            }
        }else {
            id.splice(id.findIndex(item => item === val.id), 1)
            pic -= val.invoiceAmountAvailable;
        }
        this.setState({data:[...data],invoiceId:id,invoicePic:pic});
    }
    allChange =(e)=>{
        let data = this.state.data;
        let id = [];
        let pic = 0;
        //全选按钮如果选中，列表中所有项，选中，反之全不选
        data.map((res,i)=>{
            if(e.target.checked === true){
                res.checkBox = true;
                id.push(invoiceId[i]);
                pic+=res.invoiceAmountAvailable;
                this.setState({allCheck:true});
            }else if(e.target.checked === false){
                res.checkBox = false;
                this.setState({allCheck:false});
            }
        });
        this.setState({data,invoiceId:id,invoicePic:pic});
    };
    okBtn(){
        if(this.state.invoiceId.length === 0){
            Toast.info("请选择需要申请发票的项");
             return
        }
        let isBwyData = this.state.data.find((item)=>item.id == this.state.invoiceId[0])
        // console.log(isBwyData)
        // console.log(this.state.invoiceId)
        // return
        if(this.state.invoiceId.length  > this.state.inviceCount){
            Toast.info(`您选择的开票类型不能超过${this.state.inviceCount}条`)
            return
        }
        // if(this.state.invoicePic.toFixed(2) > 1000){
        //     Toast.info("开票金额不能超过一千元")
        //     return
        // }
        this.props.history.push('/pay/invoiceInfo',{
            invoiceId:this.state.invoiceId,
            invoicePic:this.state.invoicePic.toFixed(2),
            type:this.props.location.state,
            isBwy:isBwyData.isBwy,
            invoiceSign:isBwyData.invoiceSign,
            invoiceType:tabIndex,
        })
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                <img src={notInvoice} />
                <p>暂无可开发票</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    getTitle(){
        const props = this.props.location.state;
        if(props == 1){
            return "预约出行开票"
        }
        if(props == 2){
            return "城内开票"
        }
        if(props == 4){
            return "专车预约开票"
        }
        if(props == 5){
            return "接送站开票"
        }
        if(props == 7){
            return "带货开票"
        }

    }
    getText(i){
        if(i == 0){
            return "单程包车"
        }
        if(i == 1){
            return "往返包车"
        }
        if(i == 2){
            return "按天包车"
        }
    }
    showList(i){
        const props = this.props.location.state;
        if(props == 1){
            return (
                <div className="box">
                    <div className="timeBox"><i className="icon iconfont iconshijian" /><span>{i.startTime}</span></div>
                    <div className="endBox">
                        <i className="icon iconfont iconchufadi" style={{color:'#616372'}}/>
                        <span>{i.startCity}</span> — <span className="endSpan">{i.endCity}</span>
                        {/*<span className="circleDiv">{i.startBusiness}</span>*/}
                    </div>
                    <div className="endBox">
                        <i className="icon iconfont iconpeople" style={{color:'#616372'}}/><span>{i.passengerName}</span> 
                    </div>
                    
                </div>
            )
        }
        if(props == 2 || props == 5){
            return (
                <div className="box">
                    <div className="timeBox"><i className="icon iconfont iconshijian" /><span>{i.startTime}</span></div>
                    <div className="endBox">
                        <i className="icon iconfont iconchufadi" />
                        <span className="address">{i.startCity}</span>
                    </div>

                    <div className="endBox">
                        <i className="icon iconfont iconmudedi" />
                        <span className="address">{i.endCity}</span>
                    </div>
                </div>
            )
        }
        if(props == 4){
            return (
                <div className="box">
                    <div className="type">{this.getText(i.orderType)}</div>
                    <div className="timeBox"><i className="icon iconfont iconshijian" /><span>{i.startTime}</span></div>
                    <div className="endBox">
                        <i className="icon iconfont iconchufadi" style={{color:'#616372'}}/>
                        <span>{i.startCity}</span> — <span className="endSpan">{i.endCity}</span>
                        {/*<span className="circleDiv">{i.startBusiness}</span>*/}
                    </div>
                </div>
            )
        }
        if(props == 7){
            return (
                <div className="box">
                    <div className="timeBox"><i className="icon iconfont iconshijian" /><span>{i.startTime}</span></div>
                    <div className="endBox">
                        <i className="icon iconfont iconchufadi" style={{color:'#616372'}}/>
                        <span>{i.startCity}</span> — <span className="endSpan">{i.endCity}</span>
                    </div>
                    <div className="types">{i.logisticsType}&nbsp;&nbsp;&nbsp;&nbsp;{i.logisticsWeight}kg</div>
                </div>
            )
        }
    }
    tabChange(e,index){
        console.log(e,index)
        tabIndex=index
        this.setState({
            notDataLoading:0,
            dataSource:this.state.dataSource.cloneWithRows([]),
            data: [],
            invoiceId:[],
            invoicePic:0,
            isLoading: true,
        });
        pageIndex = 1;
        this.initData();
    }
    render(){
        const _renderRow = (i,index,rowID) => (
                <div className="invoiceBox" key={rowID}>
                    <div className="time">
                        <span className="orderNo">订单号{i.orderNum}</span>
                    </div>
                    <div className="city">
                        {/* {i.checkBox}{i.orderNum}
                        <div class="view-checkbox" onClick={()=>this.onChange1(i)}>
                            {i.checkBox ? <i className="icon iconfont iconxuanzhong1"/> : null}
                        </div> */}
                        <CheckboxItem key={i.orderNum} onChange={(e) => this.onChange(i,e,Number(rowID))} checked={i.checkBox}/>
                        {this.showList(i)}
                        <div  className="pic"><span className="actualAmount">￥{i.invoiceAmountAvailable}</span></div>
                    </div>
                </div>
        );
        return(

            <div className="invoice">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >{this.getTitle()}</NavBar>

                <Tabs prerenderingSiblingsNumber={false} tabs={this.state.tabs} swipeable={false} onChange={(e,index)=>this.tabChange(e,index)}>
                    <div className="con">
                        {this.notData()}
                        <ListView
                            className="invoiceList"
                            ref={el => this.lv = el}
                            dataSource={this.state.dataSource}
                            renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> :"没有更多")}
                            renderRow={_renderRow}
                            style={{
                                height: '100%',
                                // overflow: 'auto',
                            }}
                            onEndReached={this._onEndReached.bind(this)}
                            scrollRenderAheadDistance={300}
                            onEndReachedThreshold={60}
                            initialListSize={20}
                        />
                    </div>
                </Tabs>
                <div  className="allBtn">
                    {/*<div className="allNum">{this.state.invoiceId.length}个订单，共￥{this.state.invoicePic.toFixed(2)}元</div>*/}
                    <div className="button">
                        <List className="allList">
                            <span>￥{this.state.invoicePic.toFixed(2)}</span>
                            {/* <CheckboxItem onChange={(e) => this.allChange(e)} checked={this.state.allCheck}>
                                全选  <span>￥{this.state.invoicePic.toFixed(2)}</span>
                            </CheckboxItem> */}
                        </List>
                        <div className="btn"><button onClick={()=> this.okBtn()}>开发票</button></div>
                    </div>

                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/index.js